import {
    capitalizeFirstLetter, convertScripResponseWatchlistGrid, fnRoundDown, fnRoundUp,
    getAveragePrice, getDecryptLocalStorage, getDynamicParamsForToFixed, getMktSegIdFromApiExchangeName,
    getNumberSuffix, getMktStatusColor
} from '../../utils/global_functions';
import {
    scripFromInstandExchangeDetails, getUserAllOrders, getUserSipOrders, getUserMultiScripOrders,
    getUserTradeOrderdata, updateUserSipOrders, getLTPPriceBandMaster, marginPlusParams, bannedScripStatus,
    marketStatus, orderCart, getUserGtdOrders, gtdOrdersHistory, cancelSingleOrders
} from "../../apis";
import {
    WATCHLIST_GRID_INDEX, ALL_ORDERS_STATUS, BUSINESS_LAYER_RESPONSE,
    ORDER_PRODUCT_TYPES, MARKET_SEGMENT_ID, ORDER_VALIDITY, TL_INDEX, MULTIPLIER,
    MARGIN_PARAMS_DPR_FLAG, BEST5_INDEX, ORDER_STATUS_FROM_RESPONCE,
    ORDER_DISPLAY_STATUS, FACILITY_NUM, EXCHANGE_NAME_API, SCRIP_INSTRUMENTS,
    ORDER_ENTRY_TYPES
} from "../../utils/global_variables";
import { _getScripsInfo } from '../watchlist';
import uniqBy from 'lodash/uniqBy';
import { _getProductType } from '../netPosition';
import moment from 'moment';
import { _getFutureTabData } from '../marketOverview';
import { getOrderCartApi, getUserSipOrderHistory } from '../../apis/transactional';


async function _getExchangeWiseScripInfo(scripInfo) {
    try {
        const objResp = await scripFromInstandExchangeDetails({ strInstrument: scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT].replace(/\s+/g, '').toUpperCase(), strSymbol: scripInfo?.[WATCHLIST_GRID_INDEX.SYMBOL].replace(/\s+/g, '').toUpperCase() });
        const arrAllExchangesScrips = objResp?.data?.result?.hits?.hits?.map(scrip => scrip?._source);
        const arrConvertedAllExchangesScrips = convertScripResponseWatchlistGrid(arrAllExchangesScrips);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrConvertedAllExchangesScrips };
    } catch (error) {
        return { status: false, message: 'FAILURE', data: error };
    }
}


//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
async function _getAllOrders(objOrderBookPayload, productTypeData, objLoginSession) {
    /*about parameters ==>
    1) objOrderBookPayload:it contains two keys offSet and limit for Order Api
    2) arrWhatsHotData:it is an array which have objects of DontMiss Chipss

    about Function ==> This Function give array of all orders first of all it have objResp it is Response from order api and
    it have objAllTradeTable it is list of all trade orders in this function created new object for each order in which added
    trades means all trade orders as per order_id added trade orders to each object of order and next added dontMiss Chips.
    At last in this function filtering the array of order by orderStatus this function returen all Orders, completed orders and open oreders
    */
    try {


        const objResp = await getUserAllOrders(objOrderBookPayload);

        const arrTradeOrdersPayload = [];
        objResp?.data?.data?.forEach((each) => {
            if (+each?.traded_quantity > 0) {
                arrTradeOrdersPayload.push(each.order_id);
            }
        }
        );
        const arrData = objResp.data.data?.map((item) => ({ ...item, MktSegIdandToken: getMktSegIdFromApiExchangeName(item.exchange) + '_' + item.scrip_token }));
        const arrUniqueScrips = uniqBy(arrData, 'MktSegIdandToken')?.map((item) => ({ mkt: item.exchange, "token": item.scrip_token }));
        const arrUniqueorderIdentifier = uniqBy(arrData, 'order_identifier')?.map((item) => item.order_identifier);
        const objScripInfoResp = await _getScripsInfo(arrUniqueScrips);
        const arrScripInfo = objScripInfoResp?.data.objScripsResp.result;
        const objAllTradeTable = arrTradeOrdersPayload?.length > 0 && await _getTradeOrders({
            offSet: 1,
            limit: 100,
            order_ids: arrTradeOrdersPayload
        });
        const objRespOrderCart = await _getOrderCart(arrUniqueorderIdentifier);
        const arrOrderCartDetails = objRespOrderCart?.data;
        const objOrdersLength = objResp?.data.metadata;
        const arrOrders = objResp.data.data.map((element, i) => {
            const arrTradeOrders = objAllTradeTable?.data?.length > 0 ? objAllTradeTable?.data?.filter((each) => each.order_id === element.order_id) : [];
            const nIndex = arrScripInfo?.findIndex((each) => each.MktSegId + '_' + each.nToken === getMktSegIdFromApiExchangeName(element.exchange) + '_' + element.scrip_token);
            const nOrderCartIndex = arrOrderCartDetails?.findIndex((each) => each?.ordercartId === element?.order_identifier); // Deepti B : 04-04-2024 : Order Cart - updated field name
            //BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem - Start
            let prodType = element?.product_type;
            if (element.exchange.includes('EQ') && prodType === ORDER_PRODUCT_TYPES.INTRADAY) {
                prodType = ORDER_PRODUCT_TYPES.MARGIN;
            }
            else if (!element.exchange.includes('EQ') && prodType === ORDER_PRODUCT_TYPES.DELIVERY) {
                prodType = ORDER_PRODUCT_TYPES.CARRYFORWARD;
            }

            //BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem - End
            return {
                expandCell: '',
                title: element.symbol,
                exchange: arrScripInfo[nIndex]?.sExchange,// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – exhange added from scripInfo api
                series: arrScripInfo[nIndex]?.sSeries,// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – series added from scripInfo api
                expiryDate: arrScripInfo[nIndex]?.nExpiryDate1,
                instrument: arrScripInfo[nIndex]?.sInstrumentName,
                optionType: arrScripInfo[nIndex]?.sOptionType,
                mktIdToken: arrScripInfo[nIndex]?.MktSegId + '_' + element.scrip_token,
                mktId: getMktSegIdFromApiExchangeName(element.exchange), //arrScripInfo[nIndex]?.MktSegId,
                strikePrice: arrScripInfo[nIndex]?.nStrikePrice1,
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                date: element?.exchange_timestamp.split(" ")[0],
                time: moment(element?.exchange_timestamp).format("hh:mm:ss A, DD MMM 'YY"),
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                type: element.transaction_type,
                prodType: prodType,//BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem 
                exchangeWiseProductType: element.product_type, // Vinit R : 21-02-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start / End
                productTypeDesc: _getProductType(element.product_type, element.exchange, productTypeData, objLoginSession),
                orderType: element?.order_type,
                qty: `${element.traded_quantity}/${element.total_quantity}`,
                pendingQuantity: element.pending_quantity,
                totalQuantity: element.total_quantity,
                price: parseFloat(element.order_price)?.toFixed(getDynamicParamsForToFixed(element.exchange)),// * arrScripInfo[nIndex]?.DecimalLocator) / arrScripInfo[nIndex]?.DecimalLocator)?.toFixed(getDynamicParamsForToFixed(element.exchange)),
                status: element.status === "PENDING" && element.traded_quantity > 0 ? ORDER_STATUS_FROM_RESPONCE.PARTIALLYCOMPLETED_MAIN : element.status,
                ltp: (0)?.toFixed(getDynamicParamsForToFixed(element.exchange)),
                orderNo: element?.order_id,
                validity: element.validity,
                bracket_details: element.bracket_details,
                scripToken: element.scrip_token,
                trades: arrTradeOrders,
                orderIdentifier: element.order_identifier,
                tradedQuantity: element.traded_quantity,
                decimalLocator: arrScripInfo[nIndex]?.DecimalLocator,
                decimalLocatorLength: getDynamicParamsForToFixed(element.exchange),
                priceTick: (arrScripInfo[nIndex]?.nPriceTick / arrScripInfo[nIndex]?.DecimalLocator),
                regularLot: arrScripInfo[nIndex]?.nRegularLot,
                assetToken: arrScripInfo[nIndex]?.nAssetToken,
                error_reason: element?.error_reason,
                trigger_price: element?.trigger_price,
                market_lot: element?.market_lot,
                ordercartName: nOrderCartIndex >= 0 ? arrOrderCartDetails[nOrderCartIndex]?.ordercartName : '',// Deepti B : 04-04-2024 : Order Cart - updated field name
                exchangeSegment: element.exchange,// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order –  added exchangeSegment 
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                initiated_by: element?.initiated_by,
                modified_by: element?.modified_by,
                averagePrice: arrTradeOrders?.length > 0 ? getAveragePrice(arrTradeOrders, element.exchange) : '-', //Vaibhav S : 26-02-2024 : AveragePriceCalculation added:Start
                exchangeDateTime: moment(element?.exchange_timestamp).format("hh:mm:ss A, DD MMM 'YY"),//arrTradeOrders?.length > 0 ? moment(arrTradeOrders[0]?.trade_timestamp).format("hh:mm:ss A, DD MMM 'YY") : '-',
                exchangeOrderNumber: element?.exchange_order_no,
                sSurvMeasureDescription: arrScripInfo[nIndex]?.sSurvMeasureDescription,
                sQtyUnit: arrScripInfo[nIndex]?.sQtyUnit,
                sISINCode: arrScripInfo[nIndex]?.sISINCode,//Azeem K : 16-12-2023 :adde ISIN code
                is_amo_order: element?.is_amo_order,
                disclosed_quantity: element?.disclosed_quantity,
                nPriceNum: arrScripInfo[nIndex]?.nPriceNum ? arrScripInfo[nIndex]?.nPriceNum : 1,
                nPriceDen: arrScripInfo[nIndex]?.nPriceDen ? arrScripInfo[nIndex]?.nPriceDen : 1,
                nAVMBuyMargin: arrScripInfo[nIndex]?.nAVMBuyMargin ? arrScripInfo[nIndex]?.nAVMBuyMargin : 1,
                nAVMSellMargin: arrScripInfo[nIndex]?.nAVMSellMargin ? arrScripInfo[nIndex]?.nAVMSellMargin : 1,
                validity_date: element?.validity_days ? moment(element?.order_timestamp).add(element?.validity_days, 'days')?.format("DD MMM 'YY")?.toString() : '',
                max_transaction_quantity: arrScripInfo[nIndex]?.nMaxSingleTransactionQty,//BREEZE-16 : ManasaB : 04-11-2024 : Order Slicing SAT issue 
                //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
                modifyReorderProductType: arrScripInfo[nIndex]?.MktSegId == MARKET_SEGMENT_ID.NSE_CASH || arrScripInfo[nIndex]?.MktSegId == MARKET_SEGMENT_ID.BSE_CASH || arrScripInfo[nIndex]?.MktSegId == MARKET_SEGMENT_ID.MSX_CASH ? ORDER_PRODUCT_TYPES.MARGIN : ORDER_PRODUCT_TYPES.INTRADAY,
                modifyReorderProductTypeDescr: _getProductType(ORDER_PRODUCT_TYPES.INTRADAY, element.exchange, productTypeData, objLoginSession),
                //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
            };
        }

        );
        //   DontMiss Logic commented as BA (Mithun) suggested dontMiss will not show for orders

        // const hotList = new Map();

        // arrWhatsHotData?.forEach(({ mktid, token, class: class1, class2, event, date, Desc }) => {
        //     if (hotList.has(`${mktid}_${token}`)) {
        //         const arrHotList = hotList.get(`${mktid}_${token}`);
        //         arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
        //         hotList.set(`${getMktSegIdFromMappedMktSegId(mktid)}_${token}`, arrHotList);
        //     } else {
        //         hotList.set(`${getMktSegIdFromMappedMktSegId(mktid)}_${token}`, [{ color: class1, bg_color: class2, event, date, Desc }]);
        //     }
        // });


        // for (let i = 0; i < allOrders?.length; i++) {
        //     if (hotList?.has(allOrders[i]?.mktId + '_' + allOrders[i]?.scripToken)) {
        //         allOrders[i].dontMiss = hotList?.get(allOrders[i]?.mktId + '_' + allOrders[i]?.scripToken);
        //     } else {
        //         allOrders[i].dontMiss = [];
        //     }
        // }

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrOrders, objOrdersLength } };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}
//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


async function _getOrderCart(arrPayload) {
    //about parameters ==>
    // 1)arrPayload: it is an array of orderIdentifier numbers requre for API
    //  about function ==> this function use for getting Order Cart details this function return array of all Order Cart details 
    try {
        const objResp = await orderCart(arrPayload);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp?.data?.data };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };

    }
}

async function _getAllSipOrders(objSipOrderPayload, isHistoryAllowed, arrWhatsHotData) {
    try {
        const resp = await getUserSipOrders(objSipOrderPayload);
        const allSIPids = resp?.data?.data?.map((element, i) => {
            return element?.sip_id;
        });
        let arrGroupedTransactions = [];
        if (isHistoryAllowed) {
            try {
                const respObj = await getUserSipOrderHistory(allSIPids);
                arrGroupedTransactions = respObj && respObj?.data?.data?.reduce((acc, obj) => {
                    if (!acc[obj.sSIPId]) {
                        acc[obj.sSIPId] = [];
                    }
                    acc[obj.sSIPId].push(obj);
                    return acc;
                }, {});
            } catch (error) {
                console.error(error.message);
            }
        } else { }
        const dayRegex = /\b(\d+)\s*(?:st|nd|rd|th)\b/g;

        const allOrders = resp?.data?.data?.map((element, i) => {
            const order_history = arrGroupedTransactions[element?.sip_id] !== undefined ? arrGroupedTransactions[element?.sip_id] : [];
            const pending_installments = order_history?.length ? element?.no_of_installments - order_history?.length : 0;
            const completed_installments = arrGroupedTransactions[element?.sip_id] !== undefined ? arrGroupedTransactions[element?.sip_id]?.filter(el => { return el?.trade_status == 'COMPLETED' || el?.trade_status == 'PARTIALLYCOMPLETED' || el?.trade_status == 'COMPLETED (CA Adjusted)'; }).length : 0;
            return {
                id: element?.sip_id,
                expandCell: '',
                symbol: element?.symbol,
                assest_type: element?.assest_type,
                bDetail: element?.bDetail,
                bModify: element?.bModify,
                bStop: element?.bStop,
                bView: element?.bView,
                caa_remark: element?.caa_remark,
                // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
                cap_price: parseFloat(element?.cap_price)?.toFixed(getDynamicParamsForToFixed(element?.exchange)),
                created_date: moment(element?.created_date)?.format("DD MMM 'YY"),
                exchange: element?.exchange?.slice(0, 3),
                frequency_start_date: moment(new Date(element?.frequency_start_date))?.format("DD MMM \'YY"),
                installment_date: element?.installment_date?.toUpperCase() !== 'NA' ? moment(element?.installment_date)?.format("DD MMM 'YY") : element?.installment_date,
                ltp: '0.00',
                price: 'Market',
                // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
                created_by: element?.created_by,
                display_transaction_type: element?.display_transaction_type,
                exchangeSegment: element?.exchange,
                executed_installments: element?.executed_installments,
                frequency_details: element?.frequency_type === "MONTHLY" ? (element?.installment_date !== 'NA' ? new Date(element?.installment_date)?.getDate() + getNumberSuffix(new Date(element?.installment_date)?.getDate()) + " day of every month" : 'NA') : element?.frequency_details,
                frequency_type: element?.frequency_type,
                invested_qty_or_val: parseFloat(element?.invested_qty_or_val),
                pendingQuantity: (Number(element?.invested_qty_or_val) - Number(element?.traded_quantity)),
                investment_type: element?.investment_type,
                investment_value: parseFloat(element?.investment_value),
                modified_by: element?.modified_by,
                no_of_installments: element?.no_of_installments,
                scrip_token: element?.scrip_token,
                series: element?.series,
                // Vinit Raut : 23-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- Start  
                status: (element?.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || element?.status === ALL_ORDERS_STATUS.ORDER_STATUS_RUNNING) ? ALL_ORDERS_STATUS.ORDER_STATUS_ACTIVE : element?.status,
                // Vinit Raut : 23-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- End
                traded_quantity: element?.traded_quantity,
                transaction_type: element?.transaction_type,
                updated_status: element?.updated_status,
                executed_and_numberof_installment: `${element?.executed_installments}/${element?.no_of_installments}`,
                segment_id: getMktSegIdFromApiExchangeName(element?.exchange) + '_' + element?.scrip_token,
                time: element?.created_date,
                cmv: 0.00,
                orderHistory: order_history,
                rejected_installments: order_history?.length ? element?.no_of_installments - (completed_installments + pending_installments) : 0,
                pending_installments: pending_installments,
                completed_installments: completed_installments

            };
        });
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrOrders: allOrders, metadata: resp?.data?.metadata } };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }

}


async function _updateSipOrder(objupdateSipOrderPayload, product_source) {
    try {
        const resp = await updateUserSipOrders(objupdateSipOrderPayload, product_source);

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp };

    } catch (error) {

        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };

    }
}


function _getExchangeWiseProductTypes(exchange, product_type, productTypes, objLoginSession) {
    let resp = _getOrderEntryAllExchangeWiseProductTypes(productTypes, exchange, objLoginSession);

    if (exchange?.includes('EQ') && product_type === ORDER_PRODUCT_TYPES.INTRADAY) {
        product_type = ORDER_PRODUCT_TYPES.MARGIN;
        const obj = resp?.data?.find(obj => obj?.sDefaultProductType === product_type);
        return obj?.sDescription;
    } else if (exchange?.includes('FO') && product_type === ORDER_PRODUCT_TYPES.DELIVERY) {
        product_type = ORDER_PRODUCT_TYPES.CARRYFORWARD;
        const obj = resp?.data?.find(obj => obj?.sDefaultProductType === product_type);
        return obj?.sDescription;
    }
    else {
        const obj = resp?.data?.find(obj => obj?.sDefaultProductType === product_type);
        return obj?.sDescription;
    }
}
// {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }

// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start
function convertTo12HourFormat(time) {
    const [hour, minute] = time?.split(':');
    let hour12 = parseInt(hour, 10);
    hour12 = hour12 > 12 ? hour12 - 12 : hour12;
    hour12 = hour12 === 0 ? 12 : hour12;

    const period = hour < 12 ? 'AM' : 'PM';
    const formattedHour = hour12.toString().padStart(2, '0');

    return `${formattedHour}:${minute} ${period}`;

}

function formatLegIndicator(legIndicator) {
    if (typeof legIndicator === 'string') {
        return legIndicator.replace(/(\d+)L/, '$1 Legs');

    }
    return legIndicator;

}

const dayRegex = /\b(\d+)\s*(?:st|nd|rd|th)\b/g;

async function _getAllOpenOrders(openOrderPayload, objLoginSession, productTypes) {
    try {
        const { activeScripId = -1 } = openOrderPayload;
        // {/* Vinit Raut : 08-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
        let multiScrip = [];
        let spreadOrderResponse = [];

        let singleScripData = [];
        let singleScripMetaData = [];
        let sipData = [];
        let sipMetaData = [];
        let gtdData = [];
        let gtdMetaData = [];
        let multiScripData = [];
        let multiScripMetaData = [];
        let spreadData = [];
        let spreadMetaData = [];


        // Single scrip
        // Vaibhav Singh: 20-02-24:data points updated: Start
        if (activeScripId === 1 || activeScripId === -1) {
            const singleScripResponse = await getUserAllOrders(openOrderPayload);
            const arrData = singleScripResponse.data.data?.map((item) => ({ ...item, MktSegIdandToken: getMktSegIdFromApiExchangeName(item.exchange) + '_' + item.scrip_token }));
            const arrUniqueScrips = uniqBy(arrData, 'MktSegIdandToken')?.map((item) => ({ mkt: item.exchange, "token": item.scrip_token }));
            const objScripInfoResp = await _getScripsInfo(arrUniqueScrips);
            const arrScripInfo = objScripInfoResp?.data.objScripsResp.result;
            const objResponse = await getOrderCartApi();
            singleScripData = singleScripResponse?.data?.data?.map((element, i) => {
                const nIndex = arrScripInfo?.findIndex((each) => each.MktSegId + '_' + each.nToken === getMktSegIdFromApiExchangeName(element.exchange) + '_' + element.scrip_token);
                const orderCart = objResponse?.data?.data?.find((eachCart) => element?.order_identifier == eachCart?.ordercartId?.toString());
                return {
                    id: element.order_id,
                    expandCell: '',
                    symbol: element.symbol,
                    completedOrders: element.completedOrders,
                    totalOrders: element.totalOrders,
                    exchange: element.exchange.includes('CUR') ? element.exchange.replace('_CUR', 'CDS') : element.exchange.includes('_COMM') ? element.exchange.replace('_COMM', 'COMM') : element.exchange,
                    instrument: element.instrument,
                    series: element.series,
                    expiryDate: element.expiry_date,
                    strikePrice: element?.strike_price,
                    optionType: arrScripInfo[nIndex]?.sOptionType,
                    orderType: element.instrument === '' ? element.series : element?.instrument?.includes('FUT') ?
                        `${new Date(element?.expiry_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })
                            ?.replace(
                                /(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")
                        } ${element?.instrument?.slice(0, 3)}` : element?.instrument?.includes('OPT') ? `${new Date(element?.expiry_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })?.replace(
                            /(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")} ${element?.strike_price} ${element?.option_type}` : element?.series,
                    date: element.exchange_timestamp.split(" ")[0],
                    convertedDate: `${new Date(element?.exchange_timestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })?.replace(
                        /(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")}`,
                    time: convertTo12HourFormat(element.exchange_timestamp.split(" ")[1]),
                    type: element.transaction_type,
                    prodType: element.product_type,
                    qty: `${element.traded_quantity}/${element.total_quantity}`,
                    pendingQuantity: element.pending_quantity,
                    totalQuantity: element.total_quantity,
                    price: element.order_price,
                    status:
                        // element.status,
                        element?.traded_quantity === element?.total_quantity ? 'COMPLETED' : element?.traded_quantity > 0 && element?.traded_quantity < element?.total_quantity ? 'PARTIALLY COMPLETED' : element?.status === 'PENDING' ? 'OPEN' : element?.status,
                    ltp: element.ltp,
                    orderNo: element.order_id,
                    validity: element.validity,
                    first: element.first,
                    totalGainLoss: element.totalGainLoss,
                    changeInPercentage: element.changeInPercentage,
                    holdings: element.holdings,
                    totalGainPercentage: element.totalGainPercentage,
                    bracket_details: element.bracket_details,
                    scripToken: element.scrip_token,
                    trades: [],
                    tradedQuantity: element.traded_quantity,
                    MktSegId: getMktSegIdFromApiExchangeName(element?.exchange),
                    market_lot: element.market_lot,
                    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- Start 
                    exchangeWiseProductType: _getExchangeWiseProductTypes(element?.exchange, element?.product_type, productTypes, objLoginSession) ?? _getProductType(element.product_type, element.exchange, productTypes, objLoginSession),
                    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- End
                    cartIdentifier: element.order_identifier,//BT-106965 : OrderCart : ManasaB: 26 - 09 - 2024 : Smoke testing issue: Adding cart name to order in side tray and dashboard
                    orderCartName: orderCart ? orderCart?.ordercartName : ''

                };
            });
            // Vaibhav Singh: 20-02-24:data points updated: End
            singleScripMetaData = singleScripResponse?.data?.metadata;
        }
        // SIP scrip
        if (activeScripId === 3 || activeScripId === -1) {
            const sipScripResponse = await getUserSipOrders(openOrderPayload);
            sipData = sipScripResponse?.data?.data?.map((element, i) => ({
                sip_id: element.sip_id,
                expandCell: '',
                symbol: element.symbol,
                assest_type: element.assest_type,
                bDetail: element.bDetail,
                bModify: element.bModify,
                bStop: element.bStop,
                bView: element.bView,
                caa_remark: element.caa_remark,
                cap_price: element.cap_price,
                created_by: element.created_by,
                created_date: element.created_date,
                display_transaction_type: element.display_transaction_type,
                exchange: element.exchange,
                executed_installments: element.executed_installments,
                frequency_details: element?.frequency_type === "MONTHLY" ? (element?.installment_date !== 'NA' ? new Date(element?.installment_date)?.getDate() + getNumberSuffix(new Date(element?.installment_date)?.getDate()) + " day of every month" : 'NA') : element?.frequency_details,
                frequency_start_date: element.frequency_start_date,
                frequency_type: element.frequency_type,
                installment_date: element.installment_date,
                invested_qty_or_val: element.invested_qty_or_val,
                investment_type: element.investment_type,
                investment_value: element.investment_value,
                modified_by: element.modified_by,
                no_of_installments: element.no_of_installments,
                scrip_token: element.scrip_token,
                series: element.series,
                status: element.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING ? ALL_ORDERS_STATUS.ORDER_STATUS_ACTIVE : element.status,
                traded_quantity: element.traded_quantity,
                transaction_type: element.transaction_type,
                updated_status: element.updated_status,
                executed_and_numberof_installment: `${element.executed_installments}/${element.no_of_installments}`,

            }));
            sipMetaData = sipScripResponse?.data?.metadata;
        }
        // GTD scrip
        if (activeScripId === 4 || activeScripId === -1) {
            const gtdOrderResponse = await getUserGtdOrders(openOrderPayload);
            gtdData = gtdOrderResponse?.data?.data?.map((element) => (
                {
                    ...element,
                    ltp: element?.ltp || 0,
                    convertedDate: `${new Date(element?.order_timestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })?.replace(
                        /(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")}`,
                }
            ));
            gtdMetaData = gtdOrderResponse?.data?.metadata;
        }
        // Multi scrip and spread
        if (activeScripId === 2 || activeScripId === 5 || activeScripId === -1) {
            for (let i = 0; i < openOrderPayload?.orderType?.length; i++) {
                let payload = openOrderPayload?.orderType[i];
                const apiRes = await getUserMultiScripOrders(payload);
                // {/* Vinit Raut : 08-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
                if (payload.orderType === 'spread') {
                    spreadOrderResponse = apiRes?.data?.data;
                    spreadMetaData = apiRes?.data?.metadata;
                }
                else if (payload.orderType === 'multileg') {
                    multiScrip = apiRes?.data?.data;
                    multiScripMetaData = apiRes?.data?.metadata;
                }
                // {/* Vinit Raut : 08-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */ }
            }

            multiScripData = multiScrip?.map((element, i) => ({
                order_id: element.order_id,
                client_order_no: element.client_order_no,
                gateway_order_no: element.gateway_order_no,
                segment_id: element.segment_id,
                exchange: element.exchange.includes('CUR') ? element.exchange.replace('_CUR', 'CDS') : element.exchange,
                book_type: element.book_type,
                leg_indicator: formatLegIndicator(element.leg_indicator),
                orderType: element.leg_indicator === 'spread' ? 'Spread' : 'Multi Leg',
                status: element.status,
                order_timestamp: element.order_timestamp,
                convertedDate: new Date(element?.order_timestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }),
                date: element.order_timestamp.split(" ")[0],
                time: convertTo12HourFormat(element.order_timestamp.split(" ")[1]),
                convertedDateTime: new Date(element?.order_timestamp).toLocaleString('en-GB', { hour: 'numeric', minute: '2-digit', hour12: true, day: '2-digit', month: 'short', year: '2-digit' }),
                order_modified_timestamp: element.order_modified_timestamp,
                settlement_days: element.settlement_days,
                spread_symbol: element.spread_symbol,
                error_reason: element.error_reason,
                validity: element.validity,
                spread_token: element.spread_token,
                ordertime: element.ordertime,
                ltp: 0,
                leg_no_1: {
                    transaction_type: element.leg_no_1.transaction_type,
                    instrument: element.leg_no_1.instrument,
                    symbol: element.leg_no_1.symbol,
                    expiry_date: element.leg_no_1.expiry_date,
                    convertedDate: new Date(element?.leg_no_1?.expiry_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }),
                    strike_price: element.leg_no_1.strike_price,
                    option_type: element.leg_no_1.option_type,
                    total_quantity: element.leg_no_1.total_quantity,
                    traded_quantity: element.leg_no_1.traded_quantity,
                    pending_quantity: element.leg_no_1.pending_quantity,
                    order_price: element.leg_no_1.order_price,
                    scrip_token: element.leg_no_1.scrip_token,
                    exchange_order_no: element.leg_no_1.exchange_order_no,
                    product_type: element.leg_no_1.product_type,
                    price_tick: element.leg_no_1.price_tick,
                    dec_loc: element.leg_no_1.dec_loc,
                    market_lot: element.leg_no_1.market_lot
                },
                leg_no_2: {
                    transaction_type: element.leg_no_2.transaction_type,
                    instrument: element.leg_no_2.instrument,
                    symbol: element.leg_no_2.symbol,
                    expiry_date: element.leg_no_2.expiry_date,
                    strike_price: element.leg_no_2.strike_price,
                    option_type: element.leg_no_2.option_type,
                    total_quantity: element.leg_no_2.total_quantity,
                    traded_quantity: element.leg_no_2.traded_quantity,
                    pending_quantity: element.leg_no_2.pending_quantity,
                    order_price: element.leg_no_2.order_price,
                    scrip_token: element.leg_no_2.scrip_token,
                    exchange_order_no: element.leg_no_2.exchange_order_no,
                    product_type: element.leg_no_2.product_type,
                    price_tick: element.leg_no_2.price_tick,
                    dec_loc: element.leg_no_2.dec_loc,
                    market_lot: element.leg_no_2.market_lot
                },
                leg_no_3: {
                    transaction_type: element.leg_no_3.transaction_type,
                    instrument: element.leg_no_3.instrument,
                    symbol: element.leg_no_3.symbol,
                    expiry_date: element.leg_no_3.expiry_date,
                    strike_price: element.leg_no_3.strike_price,
                    option_type: element.leg_no_3.option_type,
                    total_quantity: element.leg_no_3.total_quantity,
                    traded_quantity: element.leg_no_3.traded_quantity,
                    pending_quantity: element.leg_no_3.pending_quantity,
                    order_price: element.leg_no_3.order_price,
                    scrip_token: element.leg_no_3.scrip_token,
                    exchange_order_no: element.leg_no_3.exchange_order_no,
                    product_type: element.leg_no_3.product_type,
                    price_tick: element.leg_no_3.price_tick,
                    dec_loc: element.leg_no_3.dec_loc,
                    market_lot: element.leg_no_3.market_lot
                }
            }));

            spreadData = spreadOrderResponse?.map((element) => (
                {
                    ...element,
                    ltp: element?.ltp || 0,
                    convertedDate: `${new Date(element?.order_timestamp).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })?.replace(
                        /(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")}`,
                    time: convertTo12HourFormat(element.order_timestamp.split(" ")[1]),
                    leg_no_1: {
                        ...element.leg_no_1,
                        convertedExpiryDate: new Date(element?.leg_no_1?.expiry_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }),
                        convertedExpiryMonth: new Date(element?.leg_no_1?.expiry_date).toLocaleDateString('en-GB', { month: 'short' })?.toUpperCase(),
                    },
                    leg_no_2: {
                        ...element.leg_no_2,
                        convertedExpiryDate: new Date(element?.leg_no_2?.expiry_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }),
                        convertedExpiryMonth: new Date(element?.leg_no_2?.expiry_date).toLocaleDateString('en-GB', { month: 'short' })?.toUpperCase(),
                    },
                }
            ));
        }

        // {/* Vinit Raut : 08-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
        return {
            status: true,
            message: BUSINESS_LAYER_RESPONSE.SUCCESS,
            data: { singleScripData, sipData, multiScripData, gtdData, spreadData },
            metadata: { singleScripMetaData, sipMetaData, multiScripMetaData, gtdMetaData, spreadMetaData }
        };
        // {/* Vinit Raut : 08-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */ }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}
// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End
// {/* Vinit Raut : 01-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End  */ }

async function _getTradeOrders(objOrderBookPayload) {
    /*about parameters ==>
      objOrderBookPayload:it is an object contains offSet and limits and array of all order Ids required for traders info api

    about parameters ==> This Function return array of all Trade order
*/
    try {

        const objResp = await getUserTradeOrderdata(objOrderBookPayload);


        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp?.data?.data };

    } catch (error) {

        return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [] };

    }
}

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

async function _getLTPPriceBand() {
    try {
        const resp = await getLTPPriceBandMaster();
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

async function _getMarketStatus() {
    try {
        const resp = await marketStatus();
        const modifiedData = resp?.data?.data?.map((eachMarket) => ({
            ...eachMarket, sColor: getMktStatusColor(eachMarket.marketStatus)
        }));
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: modifiedData };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

async function _getMarginPlusParams(objPayload) {
    try {
        const resp = await marginPlusParams(objPayload);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

async function _getBannedScripStatus(objPayload) {
    try {
        const resp = await bannedScripStatus(objPayload);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

function _getScripDPRRange(arrScripInfo) {
    try {
        if (arrScripInfo?.length > 0) {
            var MPHighPr = parseFloat(arrScripInfo[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE].split('-')[1]);
            var MPLowPr = parseFloat(arrScripInfo[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE].split('-')[0]);
        } else {
            MPHighPr = '0';
            MPLowPr = '0';
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [MPLowPr, MPHighPr] };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [0, 0] };
    }
}
function _getIsUserAllowedBracketCover(objLoginSession) {
    try {
        const bIsCoverOrder = objLoginSession?.data?.product_types?.includes(ORDER_PRODUCT_TYPES.COVER);
        const bIsBracketOrder = objLoginSession?.data?.product_types?.includes(ORDER_PRODUCT_TYPES.BRACKET);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [bIsCoverOrder, bIsBracketOrder] };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [false, false] };
    }
}

function _isShowValidityOrderEntry(scripOrderInfo, strValidity, selectOrderOption, isModifyOrder = false, isGTTAllowed) {
    try {
        let bShowValidity = true;
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH ||
            scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH ||
            scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH) {
            if (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL_MKT && strValidity === ORDER_VALIDITY.IOC) {
                bShowValidity = false;
                return bShowValidity;
            } else { }
            // Azeem K:07-05 - 2025 : added conditionally GTT and GTD --Start
            if (!isGTTAllowed) {
                if (!(selectOrderOption?.productType === ORDER_PRODUCT_TYPES.DELIVERY ||
                    selectOrderOption?.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD) && strValidity === ORDER_VALIDITY.GTD) {
                    bShowValidity = false;
                    return bShowValidity;
                } else { }

                if (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL_MKT && strValidity === ORDER_VALIDITY.GTD) {
                    bShowValidity = false;
                    return bShowValidity;
                } else { }
            }
            // Azeem K:07-05 - 2025 : added conditionally GTT and GTD --End

        } else { }
        // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
        //add  conditions for GTT  validity
        if (!(selectOrderOption?.productType === ORDER_PRODUCT_TYPES.DELIVERY ||
            selectOrderOption?.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD) && strValidity === ORDER_VALIDITY.GTT) {
            bShowValidity = false;
            return bShowValidity;
        }

        if ((selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL || (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH && scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES] === 'BO') || (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH && (scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES] === 'BO' || scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL]?.endsWith('7'))) || isModifyOrder) && strValidity === ORDER_VALIDITY.GTT) {
            bShowValidity = false;
            return bShowValidity;
        }
        // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: bShowValidity };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: false };
    }
}

//Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Marketdepth live data not reflecting - Start
function _handleOrderEntryLiveData(arrDetails, arrScripExchanges, arrDistinctScripExchanges, liveFeedType) {
    const arrScripsExchanges = arrDistinctScripExchanges;
    try {
        if (arrDistinctScripExchanges?.length > 0 && arrDetails?.length > 0) {
            for (let i = 0; i < arrDistinctScripExchanges?.length; i++) {
                if (liveFeedType === 'touchline') {
                    // Maaz A: For Touchline Handling
                    if (arrScripsExchanges[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID] === arrDetails[TL_INDEX.SEGMENT_ID] && arrScripsExchanges[i][WATCHLIST_GRID_INDEX?.TOKEN] === arrDetails[TL_INDEX.TOKEN]) {
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrDetails[TL_INDEX.LAST_TRADE_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrDetails[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrDetails[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.BID_PRICE] = arrDetails[TL_INDEX.BUY_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrDetails[TL_INDEX.BUY_QTY];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ASK_PRICE] = arrDetails[TL_INDEX.SELL_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ASK_QTY] = arrDetails[TL_INDEX.SELL_QTY];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.HIGH] = arrDetails[TL_INDEX.HIGH_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LOW] = arrDetails[TL_INDEX.LOW_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.OPEN] = arrDetails[TL_INDEX.OPEN_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.CLOSE] = arrDetails[TL_INDEX.CLOSE_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.VOLUME] = arrDetails[TL_INDEX.VOLUME];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ATP] = arrDetails[TL_INDEX.AVG_TRADED_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] = arrDetails[TL_INDEX.DAILY_PRICE_RANGE];
                        break;
                    } else { }
                } else {
                    // Maaz A: For Best Five Handling
                    if (arrScripsExchanges[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID] === arrDetails[BEST5_INDEX.SEGMENT_ID] && arrScripsExchanges[i][WATCHLIST_GRID_INDEX?.TOKEN] === arrDetails[BEST5_INDEX.TOKEN]) {
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrDetails[BEST5_INDEX.LAST_TRADE_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrDetails[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrDetails[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.BID_PRICE] = arrDetails[BEST5_INDEX.BUY_PRICE_1];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrDetails[BEST5_INDEX.BUY_QTY_1];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ASK_PRICE] = arrDetails[BEST5_INDEX.SELL_PRICE_1];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ASK_QTY] = arrDetails[BEST5_INDEX.SELL_QTY_1];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.HIGH] = arrDetails[BEST5_INDEX.HIGH_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.LOW] = arrDetails[BEST5_INDEX.LOW_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.OPEN] = arrDetails[BEST5_INDEX.OPEN_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.CLOSE] = arrDetails[BEST5_INDEX.CLOSE_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.VOLUME] = arrDetails[BEST5_INDEX.VOLUME];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.ATP] = arrDetails[BEST5_INDEX.AVG_TRADED_PRICE];
                        arrScripExchanges[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] = arrDetails[BEST5_INDEX.DAILY_PRICE_RANGE];
                        break;
                    } else { }
                }
            }
        };
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [...arrScripsExchanges] };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [...arrScripsExchanges] };
    }
}
//Maaz A : 07-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - Marketdepth live data not reflecting - End

function _getOrderEntryAllExchangeWiseProductTypes(productTypes, strSelectedExchName, objLoginSession) {
    let arrAllExchangeWiseProductTypes = [];

    try {
        if (productTypes?.length > 0 && strSelectedExchName) {
            const arrSelectedProductType = objLoginSession?.data?.product_types_exchange[strSelectedExchName];
            if (arrSelectedProductType?.length > 0) {
                const arrUpdatedProductTypes = [];
                arrSelectedProductType?.forEach(strProdType => {
                    if (strSelectedExchName.includes('EQ') && strProdType === ORDER_PRODUCT_TYPES.INTRADAY) {
                        var objProductTypeInfo = productTypes?.find((eachObj) => {
                            return eachObj?.sDefaultProductType === ORDER_PRODUCT_TYPES.MARGIN;
                        });
                    } else if (!strSelectedExchName.includes('EQ') && strProdType === ORDER_PRODUCT_TYPES.DELIVERY) {
                        objProductTypeInfo = productTypes?.find((eachObj) => {
                            return eachObj?.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD;
                        });
                    } else if (strProdType === ORDER_PRODUCT_TYPES.BTST) {
                        objProductTypeInfo = productTypes?.find((eachObj) => {
                            return eachObj?.sDefaultProductType === ORDER_PRODUCT_TYPES.PTST;
                        });
                    } else {
                        objProductTypeInfo = productTypes?.find((eachObj) => {
                            return eachObj?.sDefaultProductType === strProdType;
                        });
                    }
                    if (objProductTypeInfo) {
                        arrUpdatedProductTypes.push(objProductTypeInfo);
                    } else { }
                });
                arrAllExchangeWiseProductTypes = [...arrUpdatedProductTypes].sort((a, b) => Number(a.nDefaultProductSequence) - Number(b.nDefaultProductSequence));
            } else {
                arrAllExchangeWiseProductTypes = [];
            }
        }
        else {
            arrAllExchangeWiseProductTypes = [];
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrAllExchangeWiseProductTypes };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [] };
    }
}

function _orderEntryComputeMPRange(objOrderMarginParams, arrActiveScripLiveData, scripOrderInfo, MPHighPr, MPLowPr) {
    try {

        // 0 --> ClosePrice, 1 --> LTP,  2 --> BasePrice
        const { nDPRValidationOn: MPDPRFlag, nDPRPercentage } = objOrderMarginParams;
        if (MPDPRFlag === MARGIN_PARAMS_DPR_FLAG.CLOSE_PRICE) {
            var MPSetPrice = parseFloat(arrActiveScripLiveData[WATCHLIST_GRID_INDEX.CLOSE]);
        }
        else if (MPDPRFlag === MARGIN_PARAMS_DPR_FLAG.LTP) {
            MPSetPrice = parseFloat(arrActiveScripLiveData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
        }
        // else if (MPDPRFlag === MARGIN_PARAMS_DPR_FLAG.BASE_PRICE) {
        //     MPSetPrice = MPBasePrice;
        // }
        else { }

        //Proceed to calculate Virtual High and Low Price
        const MPDPRRangePerc = nDPRPercentage / MULTIPLIER.TEN_THOUSAND;
        const MPVirtualHighPr = MPSetPrice + (MPSetPrice * MPDPRRangePerc);
        const MPVirtualLowPr = MPSetPrice - (MPSetPrice * MPDPRRangePerc);

        let MPActualHighPr = parseFloat(fnRoundDown(MPHighPr, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
        let MPActualLowPr = parseFloat(fnRoundDown(MPLowPr, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));

        //Now Proceed to calculate Actual High and Low Price
        if (MPHighPr !== 0)
            MPActualHighPr = Math.min(MPHighPr, MPVirtualHighPr);
        else
            MPActualHighPr = MPVirtualHighPr;

        if (MPLowPr !== 0)
            MPActualLowPr = Math.max(MPLowPr, MPVirtualLowPr);
        else
            MPActualLowPr = MPVirtualLowPr;

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [MPActualHighPr, MPActualLowPr] };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [0, 0] };
    }
}

function _orderEntryComputeBuySideMPPriceRange(objOrderMarginParams, arrActiveScripLiveData, MPActualHighPr, MPActualLowPr, orderInputs, scripOrderInfo) {
    try {
        const { nMinDiffLimitPricePercentage, nMinDiffLimitTriggerPricePercentage, nMinDiffTriggerPricePercentage, nProfitPricePercentage } = objOrderMarginParams;
        const MPTrigLimitPerc = nMinDiffLimitPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const MPLimitTrigPercMin = nMinDiffLimitTriggerPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const MPLimitTrigPerc = nMinDiffTriggerPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const profitPricePerc = nProfitPricePercentage / MULTIPLIER.TEN_THOUSAND;
        let dblLTP1 = 0;
        if (isNaN(parseFloat(orderInputs?.scripPrice)) || parseFloat(orderInputs?.scripPrice) === 0)
            dblLTP1 = parseFloat(arrActiveScripLiveData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
        else
            dblLTP1 = parseFloat(orderInputs?.scripPrice);

        /* Calculate Trigger Low Side        */
        // Low Trigger Price Range should be calculated as
        // MAX(IF(OR(ISBLANK(LIMITPRICE1), LIMITPRICE1=0, LIMITPRICE1>(MAX(MIN(LTP1-(LTP1*TRIGGER_LIMIT_PERCENT%),LTP1-(LTP1*LTP_LIMIT_PERCENT%),Actual_High_Range),Actual_Low_Range)), LIMITPRICE1< Actual_Low_Range),Actual_Low_Range,LIMITPRICE1)+(LTP1*TRIGGER_LIMIT_PERCENT%),LTP1-(LTP1*LTP_TRIGGER_PERCENT%))
        let dblInitVal = Math.min((dblLTP1 - (dblLTP1 * MPTrigLimitPerc)), (dblLTP1 - (dblLTP1 * MPLimitTrigPercMin)));
        let dblVal1 = Math.min(dblInitVal, MPActualHighPr);
        let dblVal2 = Math.max(dblVal1, MPActualLowPr);

        let dblRes = 0;
        const selMPPrice = orderInputs?.intradayLimit;
        if (isNaN(parseFloat(selMPPrice)) || parseFloat(selMPPrice) === 0 || parseFloat(selMPPrice) > dblVal2 || parseFloat(selMPPrice) < MPActualLowPr) {
            dblRes = MPActualLowPr;
        }
        else {
            dblRes = parseFloat(selMPPrice);
        }

        let dblTPR = 0;
        dblTPR = Math.max((parseFloat(dblRes.toString()) + (dblLTP1 * MPTrigLimitPerc)), (dblLTP1 - (dblLTP1 * MPLimitTrigPerc)));
        let MPTriggerPriceLowRange = fnRoundUp(dblTPR, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPTriggerPriceLowRange = MPTriggerPriceLowRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator

        let MPTriggerPriceHighRange = fnRoundDown(dblLTP1, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPTriggerPriceHighRange = MPTriggerPriceHighRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator


        /* Calculate Limit Low Side
        * Actual_Low_Range     */
        let MPLimitPriceLowRange = fnRoundUp(MPActualLowPr, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPLimitPriceLowRange = MPLimitPriceLowRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator

        /* Calculate Limit High Side*/
        //MAX(MIN(IF(OR(ISBLANK(TRIGGERPRICE1),TRIGGERPRICE1=0,TRIGGERPRICE1>LTP1,TRIGGERPRICE1<(MAX(Actual_Low_Range+(LTP1*TRIGGER_LIMIT_PERCENT%),LTP1-(LTP1*LTP_TRIGGER_PERCENT%)))),LTP1,TRIGGERPRICE1)-(LTP1*TRIGGER_LIMIT_PERCENT%),LTP1-(LTP1*LTP_LIMIT_PERCENT%),Actual_High_Range),Actual_Low_Range)
        let dblLPVal1 = Math.max(MPActualLowPr + (dblLTP1 * MPTrigLimitPerc), dblLTP1 - (dblLTP1 * MPLimitTrigPerc));
        let dblLPR = 0;
        if (isNaN(parseFloat(orderInputs?.intradayTrigger))
            || parseFloat(orderInputs?.intradayTrigger) === 0
            || parseFloat(orderInputs?.intradayTrigger) > dblLTP1
            || parseFloat(orderInputs?.intradayTrigger) < dblLPVal1) {
            dblLPR = dblLTP1;
            if (!isNaN(parseFloat(orderInputs?.intradayProfit)) && parseFloat(orderInputs?.intradayProfit) > 0) {
                dblLPR = MPTriggerPriceLowRange;
            }
        }
        else {
            dblLPR = parseFloat(orderInputs?.intradayTrigger);
        }

        let dblLPRVal2 = 0;
        let dblInitLPRVal = Math.min(parseFloat(dblLPR) - (dblLTP1 * MPTrigLimitPerc), dblLTP1 - (dblLTP1 * MPLimitTrigPercMin));
        dblLPRVal2 = Math.min(dblInitLPRVal, MPActualHighPr);

        let MPLimitPriceHighRange = fnRoundDown(Math.max(dblLPRVal2, MPActualLowPr), scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPLimitPriceHighRange = MPLimitPriceHighRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);


        let profitPriceLowRange = fnRoundUp(dblLTP1 + scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]); //1 tick up form LTP
        profitPriceLowRange = profitPriceLowRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
        //Min of Acutual High and LTP + % LTP
        let profitPriceHighRange = Math.min(MPActualHighPr, dblLTP1 + (dblLTP1 * profitPricePerc));
        profitPriceHighRange = Math.max(profitPriceHighRange, parseFloat(profitPriceLowRange));
        profitPriceHighRange = fnRoundDown(profitPriceHighRange, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        profitPriceHighRange = profitPriceHighRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);

        return {
            status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: {
                MPTriggerPriceLowRange, MPTriggerPriceHighRange,
                MPLimitPriceLowRange, MPLimitPriceHighRange,
                profitPriceLowRange, profitPriceHighRange
            }
        };
    } catch (error) {
        console.error(error);
        return {
            status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: {
                MPTriggerPriceLowRange: 0, MPTriggerPriceHighRange: 0,
                MPLimitPriceLowRange: 0, MPLimitPriceHighRange: 0,
                profitPriceLowRange: 0, profitPriceHighRange: 0
            }
        };
    }
}

function _orderEntryComputeSellSideMPPriceRange(objOrderMarginParams, arrActiveScripLiveData, MPActualHighPr, MPActualLowPr, orderInputs, scripOrderInfo) {
    try {


        const { nMinDiffLimitPricePercentage, nMinDiffLimitTriggerPricePercentage, nMinDiffTriggerPricePercentage, nProfitPricePercentage } = objOrderMarginParams;
        const MPTrigLimitPerc = nMinDiffLimitPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const MPLimitTrigPercMin = nMinDiffLimitTriggerPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const MPLimitTrigPerc = nMinDiffTriggerPricePercentage / MULTIPLIER.TEN_THOUSAND;
        const profitPricePerc = nProfitPricePercentage / MULTIPLIER.TEN_THOUSAND;

        let dblLTP1 = 0;
        if (isNaN(parseFloat(orderInputs?.scripPrice)) || parseFloat(orderInputs?.scripPrice) === 0)
            dblLTP1 = arrActiveScripLiveData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE];
        else
            dblLTP1 = parseFloat(orderInputs?.scripPrice);

        // MIN(IF(OR(ISBLANK(LIMITPRICE2), LIMITPRICE2=0,LIMITPRICE2>Actual_High_Range, LIMITPRICE2< (MIN(MAX(LTP2+(LTP2*TRIGGER_LIMIT_PERCENT%),LTP2+(LTP2*LTP_LIMIT_PERCENT%),Actual_Low_Range),Actual_High_Range))),Actual_High_Range, LIMITPRICE2)-(LTP2*TRIGGER_LIMIT_PERCENT%),LTP2+(LTP2*LTP_TRIGGER_PERCENT%))
        let dblInitVal = Math.max((dblLTP1 + (dblLTP1 * MPTrigLimitPerc)), (dblLTP1 + (dblLTP1 * MPLimitTrigPercMin)));
        let dblVal1 = Math.max(dblInitVal, MPActualLowPr);
        let dblVal2 = Math.min(dblVal1, MPActualHighPr);


        let dblRes = 0;
        const selMPPrice = orderInputs?.intradayLimit;
        if (isNaN(parseFloat(selMPPrice)) || parseFloat(selMPPrice) === 0 || parseFloat(selMPPrice) > MPActualHighPr || parseFloat(selMPPrice) < dblVal2) {
            dblRes = MPActualHighPr;
        }
        else {
            dblRes = parseFloat(selMPPrice);
        }

        let dblTPR = 0;
        dblTPR = Math.min((parseFloat(dblRes) - (dblLTP1 * MPTrigLimitPerc)), (dblLTP1 + (dblLTP1 * MPLimitTrigPerc)));
        let MPTriggerPriceHighRange = fnRoundDown(dblTPR, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPTriggerPriceHighRange = MPTriggerPriceHighRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator

        let MPTriggerPriceLowRange = fnRoundUp(dblLTP1, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPTriggerPriceLowRange = (MPTriggerPriceLowRange).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);//Formatting again accd to decimal locator


        /* Calculate Limit High Side
        * Actual_High_Range     */
        let MPLimitPriceHighRange = fnRoundDown(MPActualHighPr, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPLimitPriceHighRange = MPLimitPriceHighRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator

        /* Calculate Limit Low Side*/
        //MIN(MAX(IF(OR(ISBLANK(TRIGGERPRICE2),TRIGGERPRICE2=0,TRIGGERPRICE2>(MIN(Actual_High_Range-(LTP2*TRIGGER_LIMIT_PERCENT%),LTP2+(LTP2*LTP_TRIGGER_PERCENT%))),TRIGGERPRICE2<LTP2),LTP2,TRIGGERPRICE2)+(LTP2*TRIGGER_LIMIT_PERCENT%),LTP2+(LTP2*LTP_LIMIT_PERCENT%),Actual_Low_Range),Actual_High_Range)
        let dblLPVal1 = Math.min(MPActualHighPr - (dblLTP1 * MPTrigLimitPerc), dblLTP1 + (dblLTP1 * MPLimitTrigPerc));
        let dblLPR = 0;
        if (isNaN(parseFloat(orderInputs?.intradayTrigger)) || parseFloat(orderInputs?.intradayTrigger) === 0 ||
            parseFloat(orderInputs?.intradayTrigger) > dblLPVal1 || parseFloat(orderInputs?.intradayTrigger) < dblLTP1) {
            dblLPR = dblLTP1;
        }
        else {
            dblLPR = parseFloat(orderInputs?.intradayTrigger);
        }

        let dblLPRVal2 = 0;
        let dblInitLPRVal = Math.max(parseFloat(dblLPR) + (dblLTP1 * MPTrigLimitPerc), dblLTP1 + (dblLTP1 * MPLimitTrigPercMin));
        dblLPRVal2 = Math.max(dblInitLPRVal, MPActualLowPr);

        let MPLimitPriceLowRange = fnRoundUp(Math.min(dblLPRVal2, MPActualHighPr), scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH], scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]);
        MPLimitPriceLowRange = MPLimitPriceLowRange.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]); //Formatting again accd to decimal locator

        //max of Acutual low and LTP - % LTP
        let profitPriceHighRange = fnRoundDown(dblLTP1 - scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
        let profitPriceLowRange = Math.max(MPActualLowPr, dblLTP1 - (dblLTP1 * profitPricePerc));
        profitPriceLowRange = Math.min(profitPriceLowRange, profitPriceHighRange);
        // =MIN(IF(MROUND(ACTUAL_PPR_LOW21,TICK_SIZE)<ACTUAL_PPR_LOW21,MROUND(ACTUAL_PPR_LOW21,TICK_SIZE)+TICK_SIZE,MROUND(ACTUAL_PPR_LOW21,TICK_SIZE)),ACTUAL_PPR_HIGH2)
        profitPriceLowRange = fnRoundUp(profitPriceLowRange, scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);

        return {
            status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: {
                MPTriggerPriceLowRange, MPTriggerPriceHighRange,
                MPLimitPriceLowRange, MPLimitPriceHighRange,
                profitPriceLowRange, profitPriceHighRange
            }
        };
    } catch (error) {
        return {
            status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: {
                MPTriggerPriceLowRange: 0, MPTriggerPriceHighRange: 0,
                MPLimitPriceLowRange: 0, MPLimitPriceHighRange: 0,
                profitPriceLowRange: 0, profitPriceHighRange: 0
            }
        };
    }
}

const _arrayOfLegs = (data) => {
    let arr = [];
    let temp = Object.keys(data).filter(x => x.startsWith('leg_no'));
    temp.forEach(x => {
        if (data[x].traded_quantity !== null)
            arr.push(data[x]);
    });
    return arr;
};
/*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - Start*/

const _convertLtpToTick = (amnt, tick, decLoc) => {
    let diff;
    let updatedAmnt = amnt;
    let updatedTick = (tick / decLoc);
    diff = parseFloat(amnt) % updatedTick;
    if (updatedTick / 2 < diff.toFixed(decLoc?.toString().length - 1)) {
        updatedAmnt = parseFloat(amnt) + parseFloat(diff.toFixed(decLoc?.toString().length - 1));
    } else {
        updatedAmnt = parseFloat(amnt) - diff.toFixed(decLoc?.toString().length - 1);
    }
    return updatedAmnt?.toFixed(decLoc?.toString().length - 1);
};
/*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - end*/

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

//Maaz A : 10-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
async function _getGtdOrders(objOrderBookPayload, productTypeData, objLoginSession) {
    try {
        const objResp = await getUserGtdOrders(objOrderBookPayload);
        if (objResp?.data?.data?.length > 0) {
            const arrScrips = objResp.data.data?.map((item) => ({ ...item, MktSegIdandToken: getMktSegIdFromApiExchangeName(item.exchange) + '_' + item.scrip_token }));
            const arrUniqueScripsPayload = uniqBy(arrScrips, 'MktSegIdandToken')?.map((item) => ({ mkt: item.exchange, token: item.scrip_token }));
            const objScripInfoResp = await _getScripsInfo(arrUniqueScripsPayload);
            const arrScripInfo = objScripInfoResp?.data?.objScripsResp?.result;
            const arrResp = objResp?.data?.data?.map(order => {

                const nIndex = arrScripInfo?.findIndex((each) => each.MktSegId + '_' + each.nToken === getMktSegIdFromApiExchangeName(order.exchange) + '_' + order.scrip_token);
                order['expiryDate'] = arrScripInfo[nIndex]?.nExpiryDate1;
                order['instrument'] = arrScripInfo[nIndex]?.sInstrumentName;
                order['optionType'] = arrScripInfo[nIndex]?.sOptionType;
                order['mktIdToken'] = arrScripInfo[nIndex]?.MktSegId + '_' + order.scrip_token;
                order['strikePrice'] = arrScripInfo[nIndex]?.nStrikePrice1;
                order['decimalLocator'] = arrScripInfo[nIndex]?.DecimalLocator;
                order['priceTick'] = arrScripInfo[nIndex]?.nPriceTick / arrScripInfo[nIndex]?.DecimalLocator;
                order['regularLot'] = arrScripInfo[nIndex]?.nRegularLot;
                order['assetToken'] = arrScripInfo[nIndex]?.nAssetToken;
                order['sSurvMeasureDescription'] = arrScripInfo[nIndex]?.sSurvMeasureDescription;
                order['decimalLocatorLength'] = getDynamicParamsForToFixed(order?.exchange);
                const validity_date = moment(order?.order_timestamp).add(order?.validity_days, 'days');
                order['validity_date'] = validity_date?.toString() || '';
                order['title'] = order?.symbol || '';
                order['scripToken'] = order?.scrip_token || '';
                order['mktId'] = getMktSegIdFromApiExchangeName(order?.exchange);
                order['MktSegId'] = getMktSegIdFromApiExchangeName(order?.exchange);
                order['ltp'] = 0;
                order['price'] = order?.order_price;
                order['pendingQuantity'] = order?.pending_quantity;
                order['totalQuantity'] = order?.total_quantity;
                order['expandCell'] = '';
                order['trades'] = [];
                order['orderNo'] = order?.order_id;
                order['prodTypeDesc'] = _getProductType(order?.product_type, order?.exchange, productTypeData, objLoginSession);
                // Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - Start 
                order['sSurvMeasureDescription'] = arrScripInfo[nIndex]?.sSurvMeasureDescription; // Azeem K : 11-12-2023 :added sSurvMeasureDescription
                order['order_timestamp'] = moment(order?.order_timestamp).format("hh:mm:ss A, DD MMM 'YY");
                order['validity_date'] = moment(order?.validity_date).format("DD MMM 'YY");
                order['displayQty'] = `${order.traded_quantity}/${order.total_quantity}`;
                order['sISINCode'] = arrScripInfo[nIndex]?.sISINCode;
                order['exchangeSegment'] = order?.exchange;

                // Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - End

                return order;
            });
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [...arrResp], metadata: objResp?.data?.metadata };
        } else {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [], metadata: objResp?.data?.metadata };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error, metadata: {} };
    }
}


async function _getGtdOrdersHistory(objPayload) {
    try {
        const objResp = await gtdOrdersHistory(objPayload);
        if (objResp?.data?.data?.length > 0) {
            const arrOrderHistory = objResp?.data?.data?.filter(order => { return order.traded_quantity > 0; });
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [...arrOrderHistory] };
        } else {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [] };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

async function _cancelGtdOrder(objPayload) {
    try {
        objPayload['orderNo'] = encodeURI(objPayload?.orderNo);
        const objResp = await cancelSingleOrders(objPayload);
        if (objResp?.data?.data) {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp?.data?.data };
        } else {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [] };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

//Maaz A : 10-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - Data not display in Excel – Start
function _getOrderExcelData(params) {
    //About function => this function basically give proper data as display in symbol column to excel
    //params=> params is value of particular ceel value 
    try {
        let strValue;
        if (params?.column?.colDef?.field === 'title') {
            const myColumn = params?.node?.data;
            let instrument = myColumn?.instrument?.slice(0, 3)?.startsWith('EQ') ? '' : myColumn?.instrument?.slice(0, 3);
            if (myColumn) {
                strValue = myColumn?.title + " " + myColumn?.exchange?.split('_')[0] + " " + myColumn?.series + " " + myColumn?.expiryDate?.slice(0, myColumn?.expiryDate?.length - 4) + " " + myColumn?.strikePrice + " " + myColumn?.optionType + " " + instrument;
            }
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        } else if (params?.column?.colDef?.field === 'symbol') {
            strValue = params?.node?.data?.symbol + " " + params?.node?.data?.exchange;
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
        } else if (params?.column?.colDef?.field === "leg_no_3_quantity") {
            // Adds new separate condition for leg 3 qty as backend gives us null for 3rd leg qty and we need to show "-"
            strValue = params.value ? params.value : "-";
        } else if (params?.column?.colDef?.field === "leg_no_3.order_price") {
            // Adds new separate condition for leg 3 price as backend gives us "0.00" for 3rd leg price and we need to show "-"
            strValue = params.value !== "0.00" ? params.value : "-";
        } else {
            strValue = params?.value;
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: strValue };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }

}
// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - Data not display in Excel – End

// Parshva S - 29/11/223 : BT-102679 Breeze- Multi Leg order entry - Start
const _getExpiryForScrip = async (whatsHotData, payload) => {
    const objResp = await _getFutureTabData(whatsHotData, payload);
    let temp = objResp?.data;
    if (payload?.segment_id) {
        temp = objResp?.data.filter(el => el.MktSegId === payload?.segment_id);
    }
    return temp;
};
// Parshva S - 29/11/223 : BT-102679 Breeze- Multi Leg order entry - End
// Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
function _getOrderDisplayStatus(orderStatus) {
    try {
        let strStatus = '';
        switch (orderStatus) {
            case ORDER_STATUS_FROM_RESPONCE.ADMINPENDING_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.MINIADMINPENDING:
                strStatus = ORDER_DISPLAY_STATUS.Admin_Pending;
                break;
            case ORDER_STATUS_FROM_RESPONCE.ADMINREJECT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_REJECT:
            case ORDER_STATUS_FROM_RESPONCE.OMSREJECT:
            case ORDER_STATUS_FROM_RESPONCE.OMSREJECT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.OMS_REJECT:
            case ORDER_STATUS_FROM_RESPONCE.REJECTED_MAIN:
                strStatus = ORDER_DISPLAY_STATUS.Rejected;
                break;
            case ORDER_STATUS_FROM_RESPONCE.ORDER_ERROR:
            case ORDER_STATUS_FROM_RESPONCE.ORDER_DASH_ERROR:
            case ORDER_STATUS_FROM_RESPONCE.ORDERERROR_MAIN:
                strStatus = ORDER_DISPLAY_STATUS.Order_Error;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PENDING:
                strStatus = ORDER_DISPLAY_STATUS.Open;
                break;
            case ORDER_STATUS_FROM_RESPONCE.ACTIVE:
                strStatus = ORDER_DISPLAY_STATUS.Active;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PAUSED:
                strStatus = ORDER_DISPLAY_STATUS.Paused;
                break;
            case ORDER_STATUS_FROM_RESPONCE.COMPLETED:
            case ORDER_STATUS_FROM_RESPONCE.EXECUTED:
                strStatus = ORDER_DISPLAY_STATUS.Completed;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLYCOMPLETED:
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLYCOMPLETED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLY_COMPLETED:
                strStatus = ORDER_DISPLAY_STATUS.Partially_Completed;
                break;
            case ORDER_STATUS_FROM_RESPONCE.CANCELLED:
                strStatus = ORDER_DISPLAY_STATUS.Cancelled;
                break;
            case ORDER_STATUS_FROM_RESPONCE.WITHDRAWN:
                strStatus = ORDER_DISPLAY_STATUS.Withdrawn;
                break;
            case ORDER_STATUS_FROM_RESPONCE.CLIENTXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.CLIENT_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.CLIENTXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAYXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAYXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAY_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.OMSXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.OMSXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.OMS_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGEXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGEXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGE_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.ADMINMODIFY:
            case ORDER_STATUS_FROM_RESPONCE.ADMINMODIFY_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_MODIFY:
            case ORDER_STATUS_FROM_RESPONCE.AMOSUBMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.AMO_SUBMITTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOSUBMITTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOACCEPTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOACCEPTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.AMO_ACCEPTED:
            case ORDER_STATUS_FROM_RESPONCE.ADMINACCEPT:
            case ORDER_STATUS_FROM_RESPONCE.ADMINACCEPT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_ACCEPT:
            case ORDER_STATUS_FROM_RESPONCE.A_ACCEPT:
                strStatus = ORDER_DISPLAY_STATUS.In_Process;
                break;
            // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - Start
            case ORDER_STATUS_FROM_RESPONCE.TRIGGERED:
                strStatus = ORDER_DISPLAY_STATUS.Triggered;
                break;
            case ORDER_STATUS_FROM_RESPONCE.EXPIRED:
                strStatus = ORDER_DISPLAY_STATUS.Expired;
                break;
            // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - End
            default:
                strStatus = orderStatus;
                break;
        }
        return strStatus;
    } catch (error) {
        return orderStatus;
    }

}
function _getSpreadMultiLegOrderDisplayStatus(orderStatus, qty) {
    try {
        let strStatus = '';
        switch (orderStatus) {
            case ORDER_STATUS_FROM_RESPONCE.ADMINPENDING_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.MINIADMINPENDING:
                strStatus = ORDER_DISPLAY_STATUS.Admin_Pending;
                break;
            case ORDER_STATUS_FROM_RESPONCE.ADMINREJECT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_REJECT:
            case ORDER_STATUS_FROM_RESPONCE.OMSREJECT:
            case ORDER_STATUS_FROM_RESPONCE.OMSREJECT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.OMS_REJECT:
            case ORDER_STATUS_FROM_RESPONCE.REJECTED_MAIN:
                strStatus = ORDER_DISPLAY_STATUS.Rejected;
                break;
            case ORDER_STATUS_FROM_RESPONCE.ORDER_ERROR:
            case ORDER_STATUS_FROM_RESPONCE.ORDER_DASH_ERROR:
            case ORDER_STATUS_FROM_RESPONCE.ORDERERROR_MAIN:
                strStatus = ORDER_DISPLAY_STATUS.Order_Error;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PENDING:
                if (qty > 0) {
                    strStatus = ORDER_DISPLAY_STATUS.Partially_Completed;
                } else {
                    strStatus = ORDER_DISPLAY_STATUS.Open;
                }
                break;
            case ORDER_STATUS_FROM_RESPONCE.ACTIVE:
                strStatus = ORDER_DISPLAY_STATUS.Active;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PAUSED:
                strStatus = ORDER_DISPLAY_STATUS.Paused;
                break;
            case ORDER_STATUS_FROM_RESPONCE.COMPLETED:
            case ORDER_STATUS_FROM_RESPONCE.EXECUTED:
                strStatus = ORDER_DISPLAY_STATUS.Completed;
                break;
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLYCOMPLETED:
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLYCOMPLETED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.PARTIALLY_COMPLETED:
                strStatus = ORDER_DISPLAY_STATUS.Partially_Completed;
                break;
            case ORDER_STATUS_FROM_RESPONCE.CANCELLED:
                strStatus = ORDER_DISPLAY_STATUS.Cancelled;
                break;
            case ORDER_STATUS_FROM_RESPONCE.WITHDRAWN:
                strStatus = ORDER_DISPLAY_STATUS.Withdrawn;
                break;
            case ORDER_STATUS_FROM_RESPONCE.CLIENTXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.CLIENT_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.CLIENTXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAYXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAYXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.GATEWAY_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.OMSXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.OMSXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.OMS_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGEXMITTED:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGEXMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.EXCHANGE_XMITTED:
            case ORDER_STATUS_FROM_RESPONCE.ADMINMODIFY:
            case ORDER_STATUS_FROM_RESPONCE.ADMINMODIFY_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_MODIFY:
            case ORDER_STATUS_FROM_RESPONCE.AMOSUBMITTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.AMO_SUBMITTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOSUBMITTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOACCEPTED:
            case ORDER_STATUS_FROM_RESPONCE.AMOACCEPTED_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.AMO_ACCEPTED:
            case ORDER_STATUS_FROM_RESPONCE.ADMINACCEPT:
            case ORDER_STATUS_FROM_RESPONCE.ADMINACCEPT_MAIN:
            case ORDER_STATUS_FROM_RESPONCE.ADMIN_ACCEPT:
            case ORDER_STATUS_FROM_RESPONCE.A_ACCEPT:
                strStatus = ORDER_DISPLAY_STATUS.In_Process;
                break;
            default:
                strStatus = orderStatus;
                break;
        }
        return strStatus;
    } catch (error) {
        return orderStatus;
    }

}

// Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start 
function _getSIPOrderDisplayStatus(orderStatus) {
    try {
        let strStatus = '';
        switch (orderStatus) {
            case ALL_ORDERS_STATUS.ORDER_STATUS_RUNNING:
                strStatus = ORDER_DISPLAY_STATUS.Active;
                break;

            case ALL_ORDERS_STATUS.ORDER_STATUS_STOPPED:
                strStatus = ORDER_DISPLAY_STATUS.Paused;
                break;

            case ALL_ORDERS_STATUS.ORDER_STATUS_DEACTIVATED:
                strStatus = ORDER_DISPLAY_STATUS.Stop;
                break;

            default:
                strStatus = orderStatus;
        }
        return capitalizeFirstLetter(strStatus);
    } catch (error) {
        return orderStatus;
    }

}
// Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End
//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - Start
const getSlicingRequestBody = (objOrderSliceBody, nQuantity) => {
    let objNewOrderSliceBody = {};
    objNewOrderSliceBody = Object.assign({}, objOrderSliceBody);
    objNewOrderSliceBody['net_quantity'] = objOrderSliceBody['net_quantity'] > 0 ? nQuantity : -nQuantity;
    return objNewOrderSliceBody;
};
//BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - Start
const _getOrderSlicingInfo = (arrOrders, objCFT, objLoginSession) => {
    try {
        let arrSlicedRequestInfo = [];
        let exchange = JSON?.parse(getDecryptLocalStorage('ORDER_SLICING_EXCHANGE'));
        // To fix crash issue and let normal flow continue if order slicing is disabled or if order slicing exchange values not present in localstorage
        if (Object.keys(objCFT).length > 0 && objCFT.ORDERSLICING === FACILITY_NUM.ON && exchange) {
            for (let i = 0; i < arrOrders.length; i++) {
                if (arrOrders[i]?.ScripData[0]?.ExchangeSegment === EXCHANGE_NAME_API.NSE_DERV_API && exchange[arrOrders[i]?.ScripData[0]?.ExchangeSegment] && (arrOrders[i].ScripData[0].sInstrumentName.toUpperCase().substr(0, 3) === SCRIP_INSTRUMENTS.FUT || arrOrders[i].ScripData[0].sInstrumentName.toUpperCase().substr(0, 3) === SCRIP_INSTRUMENTS.OPT) && !arrOrders[i].ScripData[0].nSpread) {
                    //BREEZE-16 : ManasaB : 04-11-2024 : Order Slicing SAT issue  - Start
                    let productType = !arrOrders[i].exchange.includes('EQ') && arrOrders[i].api_product_type === ORDER_PRODUCT_TYPES.DELIVERY ? ORDER_PRODUCT_TYPES.CARRYFORWARD : arrOrders[i].api_product_type;
                    if (productType === ORDER_PRODUCT_TYPES.INTRADAY || productType === ORDER_PRODUCT_TYPES.CARRYFORWARD) {
                        //BREEZE-16 : ManasaB : 04-11-2024 : Order Slicing SAT issue - End
                        if (arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty !== undefined && arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty !== 0
                            && Math.abs(arrOrders[i].net_quantity) > arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty) {
                            let nBalanceQty = Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty;
                            let nMainQty = Math.abs(arrOrders[i]?.net_quantity) - nBalanceQty;
                            let nRemainQty = nMainQty / arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty;
                            for (let j = 0; j < nRemainQty; j++) {
                                let objOrderInfo = getSlicingRequestBody(arrOrders[i], arrOrders[i].ScripData[0].nMaxSingleTransactionQty);
                                arrSlicedRequestInfo.push(objOrderInfo);
                            }
                            if (nBalanceQty > 0) {
                                arrSlicedRequestInfo.push(getSlicingRequestBody(arrOrders[i], nBalanceQty));
                            }
                            arrOrders[i]['orderSlicingInfo'] = [];
                            arrOrders[i]['orderSlicingInfo'].push(`${nRemainQty} order(s) of ${arrOrders[i].ScripData[0].nMaxSingleTransactionQty / arrOrders[i].ScripData[0].nRegularLot} Lots (${arrOrders[i].ScripData[0].nMaxSingleTransactionQty} Qty)`);
                            if (nBalanceQty > 0) {
                                arrOrders[i]['orderSlicingInfo'].push(`1 order of ${nBalanceQty / arrOrders[i].ScripData[0].nRegularLot} Lots (${nBalanceQty} Qty)`);
                            }
                        }
                    }
                }
                //Vaibhav Singh BREEZE-3408 : BSEFAO logic for order slicing for squareofAll
                if (arrOrders[i]?.ScripData[0]?.ExchangeSegment === EXCHANGE_NAME_API.BSE_DERV_API && exchange[arrOrders[i]?.ScripData[0]?.ExchangeSegment] && (arrOrders[i].ScripData[0].sInstrumentName.toUpperCase().substr(0, 3) === SCRIP_INSTRUMENTS.FUT || arrOrders[i].ScripData[0].sInstrumentName.toUpperCase().substr(0, 3) === SCRIP_INSTRUMENTS.OPT) && !arrOrders[i].ScripData[0].nSpread) {
                    if ((!arrOrders[i].exchange.includes('EQ') && arrOrders[i].api_product_type === ORDER_PRODUCT_TYPES.DELIVERY ? ORDER_PRODUCT_TYPES.CARRYFORWARD : arrOrders[i].api_product_type) === ORDER_PRODUCT_TYPES.INTRADAY || (!arrOrders[i].exchange.includes('EQ') && arrOrders[i].api_product_type === ORDER_PRODUCT_TYPES.DELIVERY ? ORDER_PRODUCT_TYPES.CARRYFORWARD : arrOrders[i].api_product_type) === ORDER_PRODUCT_TYPES.CARRYFORWARD) {
                        if (arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty !== undefined && arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty !== 0
                            && Math.abs(arrOrders[i].net_quantity) > arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty) {
                            let nMainQty = Math.abs(arrOrders[i]?.net_quantity) - Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty;
                            let nRemainQty = nMainQty / arrOrders[i]?.ScripData[0]?.nMaxSingleTransactionQty;
                            for (let j = 0; j < nRemainQty; j++) {
                                let objOrderInfo = getSlicingRequestBody(arrOrders[i], arrOrders[i].ScripData[0].nMaxSingleTransactionQty);
                                arrSlicedRequestInfo.push(objOrderInfo);
                            }
                            if (Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty > 0) {
                                arrSlicedRequestInfo.push(getSlicingRequestBody(arrOrders[i], Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty));
                            }
                            arrOrders[i]['orderSlicingInfo'] = [];
                            arrOrders[i]['orderSlicingInfo'].push(`${nRemainQty} order(s) of ${arrOrders[i].ScripData[0].nMaxSingleTransactionQty / arrOrders[i].ScripData[0].nRegularLot} Lots (${arrOrders[i].ScripData[0].nMaxSingleTransactionQty} Qty)`);
                            if (Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty > 0) {
                                arrOrders[i]['orderSlicingInfo'].push(`1 order of ${Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty / arrOrders[i].ScripData[0].nRegularLot} Lots (${Math.abs(arrOrders[i]?.net_quantity) % arrOrders[i].ScripData[0].nMaxSingleTransactionQty} Qty)`);
                            }
                        }
                    }
                }
            }
        }
        return { arrOrders: arrOrders, sliceRequestData: arrSlicedRequestInfo };
    } catch (error) {
        console.log('error in _getOrderSlicingInfo', error);
    }
};
//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - End
const _validateRange = (price, highRange, lowRange) => {
    // This function is created to validate range 
    // Parameters :
    // 1)price=> actual price /value of input
    // 2)highRange=> High price of the range
    // 3)lowRange=> Low price of the range


    if (!isNaN(parseFloat(price)) && !isNaN(parseFloat(highRange)) && parseFloat(highRange) > 0 && !isNaN(parseFloat(lowRange)) && (parseFloat(lowRange) > parseFloat(price) || parseFloat(price) > parseFloat(highRange))) {
        return true;
    } else {
        return false;
    }
};
//BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - End


function _isEQSIPOrderAllowed(symbol, exchangeName, series, objEqSIPScripMaster) {
    let isAllowed = false;
    if (objEqSIPScripMaster) {
        if (objEqSIPScripMaster?.allowed_series && objEqSIPScripMaster?.allowed_series?.length > 0) {
            objEqSIPScripMaster?.allowed_series?.forEach(element => {
                if (element.exchange == exchangeName && element.series == series) {
                    isAllowed = true;
                }
            });
        } else if (objEqSIPScripMaster?.allowed_scripts && objEqSIPScripMaster?.allowed_scripts?.length > 0) {
            objEqSIPScripMaster?.allowed_scripts?.forEach(element => {
                if (element.exchange == exchangeName && element.series == series && element.symbol == symbol) {
                    isAllowed = true;
                }
            });
        } else {
            isAllowed = false;
        }

    } else {
        isAllowed = false;
    }
    return isAllowed;
}
const _getSortedOrders = (data) => {
    return data.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
};
export {
    _getSortedOrders,
    _getExchangeWiseScripInfo,
    _getAllOrders,
    _getAllSipOrders,
    _updateSipOrder,
    _getAllOpenOrders,
    _getTradeOrders,
    _getLTPPriceBand,
    _getMarginPlusParams,
    _getScripDPRRange,
    _getIsUserAllowedBracketCover,
    _isShowValidityOrderEntry,
    _handleOrderEntryLiveData,
    _getOrderEntryAllExchangeWiseProductTypes,
    _orderEntryComputeMPRange,
    _orderEntryComputeBuySideMPPriceRange,
    _orderEntryComputeSellSideMPPriceRange,
    _getBannedScripStatus,
    _getMarketStatus,
    _arrayOfLegs,
    _convertLtpToTick,
    _getGtdOrders,
    _getGtdOrdersHistory,
    _cancelGtdOrder,
    _getOrderExcelData,
    _getExpiryForScrip,
    _getOrderDisplayStatus,
    _getSIPOrderDisplayStatus,
    _getOrderSlicingInfo,
    _getSpreadMultiLegOrderDisplayStatus,
    _validateRange,
    _isEQSIPOrderAllowed
};